import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";
import { useLazyQuery, useQuery ,useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { withAuth } from '@okta/okta-react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import moment from 'moment';
import ReactGA from 'react-ga';
import config from '../../config/okta.config';
import SweetAlert from 'react-bootstrap-sweetalert';
import * as FileSaver from 'file-saver';
import 'moment-timezone';
import {
  Input,Row, Col,Modal, ModalHeader, ModalBody, ModalFooter,
  Card,Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Label 
} from 'reactstrap';
import {
  Line,
  ResponsiveContainer,
  LineChart
} from 'recharts';
import {FormControl} from 'react-bootstrap'

import DataTable from 'react-data-table-component'
import {useDebouncedCallback } from 'use-debounce';
import DateTimeRangeContainer from 'react-advanced-datetimerange-picker'
import changelog from '../../CHANGELOG.md';
import ReactMarkdown from "react-markdown";
// import ResinService from '../../services/ResinService';



//Get Report details call config
const GET_REPORT_DETAIL = gql`
      query getReportDetail($FileGUID: String){
        SupplierFileDetails(filters: {
           FileGUID:$FileGUID
    }) {
     edges {
       node {
         UnitNo
          Label
          LabelNum
          ColIndex
          ColSlNum
          Val
          FileGUID
          LoadTS,
          samplingTime,
          subGroup
          bonus
          cavityID
       }
     }
    }
  }
`;




//Get Plan Details by Part Number and Revision
const GET_PLAN_DETAILS_PART = gql`
      query vwApp1factplanspecsbypartrev($PartNum: String, $PartRev: String){
        PlanDetails(filters: {
           PartNum:$PartNum,
           PartRev:$PartRev
    },sort:COL_SL_NUM_ASC) {
     edges {
       node {
         PlanID
         PartNum
         PartDesc
         PartRev
         SpecId
         Label
         LabelNum
         Method
         LSL
         USL
         SpecDataType
         Precision
         ColIndex
         ColSlNum
         Sampling
         AQL
         Characteristic
         SpecType
         SpecVal
         SpecValMin
         SpecValMax
         SpecValTOLPlus
         SpecValTOLMinus
         BonusTOL
         NumPlaces
         BaloonNum
         SheetNum
       }
     }
    }
  }
`;


//Get Plan Details by Part Number and Revision
const GET_PLAN_DETAILS = gql`
      query getPlanDetails($PlanID: String){
        PlanDetails(filters: {
           PlanIDIlike: $PlanID
    },sort:COL_SL_NUM_ASC) {
     edges {
       node {
         PlanID
         PartNum
         PartDesc
         PartRev
         SpecId
         Label
         LabelNum
         Method
         LSL
         USL
         SpecDataType
         Precision
         ColIndex
         ColSlNum
         Sampling
         AQL
         Characteristic
         SpecType
         SpecVal
         SpecValMin
         SpecValMax
         SpecValTOLPlus
         SpecValTOLMinus
         BonusTOL
         NumPlaces
         BaloonNum
         SheetNum
       }
     }
    }
  }
`;

const GET_VENDOR_NUMBER = gql`
    query getVendorNumber($ADUser: String) {
          VendorADAcntMap(filters:{
            ADUser:$ADUser
          },sort:VENDOR_NAME_ASC) {
            edges {
              node {
                VendorNum
                VendorName
              }
            }
          }
        }

`;
//Get Plan Details by Part Number and Revision
const GET_MY_REPORTS = gql`
      query getMyReports($VendorNum: String ,$Status: [String], $FromDate: String, $ToDate:String, $PartNum:String,$PONum:String, $MasterLot: String, $SubLot: String){
        vwSupplierfileheader(filters: {
          VendorNum:$VendorNum
           StatusIn: $Status
           UpdateTSGte: $FromDate
           UpdateTSLte: $ToDate
           PartNumIlike: $PartNum
           PONumIlike: $PONum
           MasterLotNumIlike: $MasterLot
           SubLotNumIlike: $SubLot
    },sort:UPDATE_TS_DESC) {
     edges {
       node {
         PartNum
         AgileDocIDVer
         PONum
         Status
         FileGUID
         UpdateTS
         LoadTS
         MasterLotNum
         SupplierLogID
         SubLotNum
         MeasureLotFlag
         LatestPlanID
         factPlanID
         MasterLotQty
         SubLotQty
         mstrLotCompletionDate
         PackingSlipNum
         sampleUnits
         ILNum
         ILUDCode
       }
     }
    }
  }
`;

//Create a new report mutation config
const UPDATE_REPORT = gql`
  mutation UpdateSupplierFile(
      $VendorNum: String
      $MasterLotNum: String
      $MasterLotQty: String
      $SubLotNum: String
      $SubLotQty: String
      $PartNum: String
      $Program: String
      $AgileDocIDVer: String
      $SupplierLogID: String
      $PONum: String
      $FileGUID: String
      $UpdateTS: String
      $factPlanID: Int
      $LoadTS: String
      $Status: String
      $sampleUnits: Int
      $ResetPlan: String
      $timeOrder: Int
      $PackingSlipNum: String
      $PartialShipmentFlag: Int
      $inspData: String
      $mstrLotCompletionDate: String
  ) {
    UpdateSupplierFile(input: {
        VendorNum:$VendorNum
        MasterLotNum: $MasterLotNum
        MasterLotQty: $MasterLotQty
        SubLotNum: $SubLotNum
        SubLotQty: $SubLotQty
        PartNum:$PartNum
        Program: $Program
        AgileDocIDVer:$AgileDocIDVer
        SupplierLogID:$SupplierLogID
        PONum:$PONum
        UpdateTS:$UpdateTS
        ResetPlan: $ResetPlan
        LoadTS:$LoadTS
        sampleUnits: $sampleUnits
        timeOrder: $timeOrder
        factPlanID:$factPlanID
        PackingSlipNum: $PackingSlipNum
        PartialShipmentFlag: $PartialShipmentFlag
        mstrLotCompletionDate: $mstrLotCompletionDate
        FileGUID:$FileGUID
        inspData:$inspData
        Status: $Status
    }) {
      iDetail {
        FileGUID

    }
    }
  }`;

const BLANK_PLAN_ID = -999999999

const MainPage = ({ history }) => {

  const [SupplierFileHeader] = useMutation(UPDATE_REPORT);
  const [myReports, setMyReports] = useState(null);
  const [listMode, setListMode] = useState("Open");
  const [showInvalidUser, setShowInvalidUser] = useState(false)
  const [diabledTiles, setDisableTiles] = useState(true)
  const [PONumber, setPONumber] = useState('');
  const [PartNumber, setPartNumber] = useState('');
  const [masterLot, setMasterLot] = useState('');
  const [subLot, setSubLot] = useState('');
  const [refresh, setRefresh] = useState(null);
  const [showVendorList, setShowVendorList] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showPlanChange, setShowPlanChange] = useState(false);
  const [planDetails,setPlanDetails]= useState(false);
  const [showDeletePrompt, setShowDeletePrompt] = useState(false);
  // const [fromDate, setFromDate] = useState(moment().startOf('month').format('MM/DD/YYYY HH:MM:SS' ));;
  // const [toDate, setToDate] = useState(moment().format('MM/DD/YYYY  HH:MM:SS'));
  const [fromDate, setFromDate] = useState(moment().subtract(1, "months").tz('America/Los_Angeles'), moment().tz('America/Los_Angeles'));
  const [toDate, setToDate] = useState(moment().add(0, "days").subtract(1, "seconds").tz('America/Los_Angeles'));
  const [selectedRow,setSelectedRow] = useState(null);
  const [details,setDetails] = useState(null);
  const [showProcessing, setShowProcessing] = useState(false);
  const [showReleaseNotes, setShowReleaseNotes] = useState(false);
  const [releaseNoteContent, setReleaseNoteContent] = useState("");
  // const [resinSettingsLoaded, setResinSettingsLoaded] = useState(false);
  // const[showResinTile, setShowResinTile] = useState(false);

  const { data } = useQuery(GET_VENDOR_NUMBER, {
    fetchPolicy: 'no-cache',
    variables: { ADUser: (window.location.hostname == 'localhost')?'VPABBARAJU1':JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.preferred_username.replace('@corp.intusurg.com', '').toUpperCase() }
  });

  const toggle = () => setDropdownOpen(prevState => !prevState);

  const [getMyReports] = useLazyQuery(GET_MY_REPORTS, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      setShowProcessing(false);
      setMyReports(data.vwSupplierfileheader.edges);
      let tfilterPO = [];
      let tfilterSublot = [];
      let tfilterMasterLot = [];
      let tfilterMaterial = [];
      setRefresh(new Date());
      //console.log(fromDate);
      data.vwSupplierfileheader.edges.map((el,i) => {
        if (listMode === 'OpenForUpload') {
          setMyReports(data.vwSupplierfileheader.edges.filter(row => row.node.ILUDCode == null));
        } else if (listMode === 'Processed') {
          setMyReports(data.vwSupplierfileheader.edges.filter(row => row.node.ILUDCode != null));
        } else {
          setMyReports(data.vwSupplierfileheader.edges);
        if (JSON.stringify(tfilterPO).indexOf(el.node.PONum)<0) {
          tfilterPO.push({name:el.node.PONum});
        }
        if (JSON.stringify(tfilterSublot).indexOf(el.node.SubLotNum)<0) {
          tfilterSublot.push({name:el.node.SubLotNum});
        }
        if (JSON.stringify(tfilterMasterLot).indexOf(el.node.MasterLotNum)<0) {
          tfilterMasterLot.push({name:el.node.MasterLotNum});
        }
        
        if (JSON.stringify(tfilterMaterial).indexOf(el.node.PartNum)<0) {
            tfilterMaterial.push({name:el.node.PartNum});
        }
      }
      });


    }
  });

  //Get Plan details call
  const [getPlanDetailsByPartData] = useLazyQuery(GET_PLAN_DETAILS_PART, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (data.PlanDetails.edges.length > 0) {
        setPlanDetails(data.PlanDetails.edges);
        getReportDetail({ variables: { FileGUID: selectedRow.node.FileGUID } });
      }
    }
  });

  //Get Plan details call
  const [getPlanDetailsData] = useLazyQuery(GET_PLAN_DETAILS, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (data.PlanDetails.edges.length > 0) {
        setPlanDetails(data.PlanDetails.edges);
        getReportDetail({ variables: { FileGUID: selectedRow.node.FileGUID } });
      }
    }
  });

  //Get Report Details call
  const [getReportDetail] = useLazyQuery(GET_REPORT_DETAIL, {
    fetchPolicy: 'no-cache',
    onCompleted: (rddata) => {
      let tdetails = [];
      // document.getElementById('loadingdiv').style.display = 'none';
      rddata.SupplierFileDetails.edges.map((el) => {
        let detailObject = {};
        detailObject['UnitNo'] = el.node['UnitNo'];
        detailObject['Label'] = el.node['Label'];
        detailObject['LabelNum'] = el.node['LabelNum'];
        detailObject['Sampling'] = el.node['Sampling'];
        detailObject['InspectionMethod'] = el.node['InspectionMethod'];
        detailObject['ColIndex'] = el.node['ColIndex'];
        detailObject['ColSlNum'] = el.node['ColSlNum'];
        detailObject['samplingTime'] = el.node['samplingTime'];
        detailObject['subGroup'] = parseInt(el.node['subGroup']);
        detailObject['Val'] = el.node['Val'];
        detailObject['bonus'] = el.node['bonus'];
        detailObject['cavityID'] = el.node['cavityID'];
        detailObject['FileGUID'] = el.node['FileGUID'];
        detailObject['UpdatedTime'] = el.node['UpdatedTime'];
        detailObject['DWLoadTS'] = el.node['DWLoadTS'];
        tdetails.push(detailObject);
      });
      setDetails(tdetails);
      exportData(tdetails);
    }
  });


  const exportData = async (details) => {
    if (planDetails && planDetails.length>0) {
    const token = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken;
    let headerObject = {}
    headerObject['partDesc'] =  planDetails[0].node.PartDesc;
    headerObject['PartNum'] = selectedRow.node.PartNum;
    headerObject['AgileDocIDVer'] = selectedRow.node.AgileDocIDVer;
    headerObject['PONum'] = selectedRow.node.PONum;
    headerObject['MasterLotNum'] = selectedRow.node.MasterLotNum;
    headerObject['MasterLotQty'] = selectedRow.node.MasterLotQty;
    headerObject['SubLotNum'] = selectedRow.node.SubLotNum;
    headerObject['SubLotQty'] = selectedRow.node.SubLotQty;
    headerObject['sampleUnits'] = (selectedRow.node.MeasureLotFlag)?selectedRow.node.sampleUnits:0;
    headerObject['timeOrder'] = selectedRow.node.timeOrder;
    headerObject['PartialShipmentFlag'] = selectedRow.node.PartialShipmentFlag;
    headerObject['PackingSlipNum'] = selectedRow.node.PackingSlipNum;
    headerObject['mstrLotCompletionDate'] = selectedRow.node.mstrLotCompletionDate;
    headerObject['Program'] = selectedRow.node.Program;
    headerObject['MasterLotQty'] = selectedRow.node.MasterLotQty;
    headerObject['SubLotQty'] = selectedRow.node.SubLotQty;
    headerObject['mstrLotCompletionDate'] = selectedRow.node.mstrLotCompletionDate;
    headerObject['PackingSlipNum'] = selectedRow.node.PackingSlipNum;
    headerObject['Status'] = selectedRow.node.Status;
    headerObject['measureLotFlag'] = selectedRow.node.MeasureLotFlag;
    headerObject['sampleUnits'] = selectedRow.node.sampleUnits;
    //console.log(headerObject);
    //console.log(details);
    //console.log(planDetails);
    const exportData = {
      header: headerObject,
      detaildata: details,
      planDetails: planDetails
    }

    let url = window.location.origin + '/export_readings';
    if (window.location.hostname == 'localhost') {
      url = 'http://' + window.location.hostname + ':5000/export_readings';
    }

    fetch(url, {
      method: 'POST',
      body: JSON.stringify({ file_id: selectedRow.node.FileGUID, exportData: exportData }),
      headers: {
        'Content-Type': 'application/json',
        'responseType': 'application/octet-stream',
        'authorization': token || null,
        'authVendorID': localStorage.getItem('loggedInVendor')
      }
    }).then(res => res.blob())
      .then(async blob => {
        FileSaver.saveAs(blob, 'Inspection_details' + selectedRow.node.FileGUID + '.xlsx');

        const res = await SupplierFileHeader({
          variables: {
            VendorNum: localStorage.getItem('loggedInVendor'),
            MasterLotNum: selectedRow.node.MasterLotNum,
            MasterLotQty: selectedRow.node.MasterLotQty,
            SubLotNum: (selectedRow.node.SubLotNum == null ? 0 : selectedRow.node.SubLotNum),
            SubLotQty: (selectedRow.node.SubLotQty == null ? 0 : selectedRow.node.SubLotQty),
            PartNum:selectedRow.node.PartNum,
            AgileDocIDVer: selectedRow.node.AgileDocIDVer,
            Program: selectedRow.node.Program,
            SupplierLogID: JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.preferred_username,
            PONum: selectedRow.node.PONum,
            FileGUID: selectedRow.node.FileGUID,
            UpdateTS: '',
            LoadTS: '',
            Status: 'Draft',
            ResetPlan:true,
            sampleUnits: (selectedRow.node.sampleUnits == null ? 0 : selectedRow.node.sampleUnits),
            inspData: [],
            factPlanID: planDetails[0].node.PlanID,
            timeOrder: (selectedRow.node.timeOrdered) ? 1 : 0,
            PackingSlipNum: selectedRow.node.PackingSlipNum,
            PartialShipmentFlag: (selectedRow.node.PartialShipmentFlag) ? 1 : 0,
            mstrLotCompletionDate: selectedRow.node.mstrLotCompletionDate
          }
        });

        if (res.data.UpdateSupplierFile.iDetail.FileGUID.trim() == 'Error processing') {
          alert('Unable to reset the plan');
      }  else {
              history.push({
                pathname: 'newreport',
                FileGUID: selectedRow.node.FileGUID
              });
              localStorage.setItem('selectedFile',selectedRow.node.FileGUID);
      }

       



        setShowProcessing(false);
      }).catch(err => alert('Unable to download data'));
    } else {
      // setPlanError(true);
    }
  } 



  

  const columns = [
    {
      name: 'Material #',
      selector: 'node.PartNum',
      sortable: true,
      style: {
          color: '#202124',
        fontSize: '14px',
        fontWeight: 500,
      }
    },
    {
      name: 'Purchase Order',
      selector: 'node.PONum',
      sortable: true,
      style: {
        color: '#202124',
        fontSize: '14px',
        fontWeight: 500,
      },
    },{
      name: 'Master Lot #',
      selector: 'node.MasterLotNum',
      sortable: true,
      style: {
        color: '#202124',
        fontSize: '14px',
        fontWeight: 500,
      },
    },{
      name: 'Sub Lot #',
      selector: 'node.SubLotNum',
      sortable: true,
      style: {
        color: '#202124',
        fontSize: '14px',
        fontWeight: 500,
      },
    },{
      name: 'Created On',
      selector: 'node.LoadTS',
      sortable: true,
      cell: (row) => <Label>{moment(row.node.LoadTS).tz('America/Los_Angeles').format('MM/DD/YYYY h:mm')} </Label>,
    },{
      name: 'Updated On',
      selector: 'node.UpdateTS',
      sortable: true,
      cell: (row) => <Label>{moment(row.node.UpdateTS).tz('America/Los_Angeles').format('MM/DD/YYYY h:mm')} </Label>,
    },{
      name: 'Status',
      selector: 'node.Status',
      sortable: true,
      style: {
        color: '#202124',
        fontSize: '14px',
        fontWeight: 500,
      },
    },{
      name: 'Created By',
      selector: 'node.SupplierLogID',
      cell: (row) => <Label>{row.node.SupplierLogID.replace('@corp.intusurg.com','')} </Label>,
      sortable: true,
      style: {
        color: '#202124',
        fontSize: '14px',
        fontWeight: 500,
      },
    },{
      name: '',
      button: true,
      cell: (row) => <button onClick={() => editReport(row,row.node.FileGUID)} style={{marginLeft:'15px',width:'100px',color:'white',backgroundColor:(row.node.Status == 'Processed')?'green':'blue'}}>{(row.node.Status == 'Processed')?'View':'Edit'}</button>,
    },{
      name: '',
      button: true,
      cell: (row) => <i class="fas fa-trash" style={{display:(row.node.Status == 'Processed')?'none':'inline'}} onClick={() => deleteReport(row,row.node.FileGUID)} ></i>,
    }];



  

  const columns1 = [
    {
      name: 'Material #',
      selector: 'node.PartNum',
      sortable: true,
      style: {
          color: '#202124',
        fontSize: '14px',
        fontWeight: 500,
      }
    },
    {
      name: 'Purchase Order',
      selector: 'node.PONum',
      sortable: true,
      style: {
        color: '#202124',
        fontSize: '14px',
        fontWeight: 500,
      },
    },{
      name: 'Master Lot #',
      selector: 'node.MasterLotNum',
      sortable: true,
      style: {
        color: '#202124',
        fontSize: '14px',
        fontWeight: 500,
      },
    },{
      name: 'Sub Lot #',
      selector: 'node.SubLotNum',
      sortable: true,
      style: {
        color: '#202124',
        fontSize: '14px',
        fontWeight: 500,
      },
    },{
      name: 'Created On',
      selector: 'node.LoadTS',
      sortable: true,
      cell: (row) => <Label>{moment(row.node.LoadTS).tz('America/Los_Angeles').format('MM/DD/YYYY h:mm')} </Label>,
    },{
      name: 'Submitted On',
      selector: 'node.UpdateTS',
      sortable: true,
      cell: (row) => <Label>{moment(row.node.UpdateTS).tz('America/Los_Angeles').format('MM/DD/YYYY h:mm')} </Label>,
    },{
      name: 'Status',
      selector: 'node.Status',
      sortable: true,
      style: {
        color: '#202124',
        fontSize: '14px',
        fontWeight: 500,
      },
    },{
      name: 'Created By',
      selector: 'node.SupplierLogID',
      cell: (row) => <Label>{row.node.SupplierLogID.replace('@corp.intusurg.com','')} </Label>,
      sortable: true,
      style: {
        color: '#202124',
        fontSize: '14px',
        fontWeight: 500,
      },
    },{
      name: '',
      button: true,
      cell: (row) => <button onClick={() => editReport(row,row.node.FileGUID)} style={{display:(row.node.ILUDCode != null)?'none':'inline',marginLeft:'15px',width:'100px',color:'white',backgroundColor:(row.node.Status == 'Processed')?'green':'blue'}}>{(row.node.ILUDCode == null)?'Open for upload':'null'}</button>,
    },{
      name: '',
      button: true,
      cell: (row) => <button onClick={() => editReport(row,row.node.FileGUID)} style={{display:(row.node.ILUDCode == null)?'none':'inline',marginLeft:'15px',width:'100px',color:'white',backgroundColor:(row.node.Status == 'Processed')?'green':'blue'}}>{(row.node.Status == 'Processed')?'View':'Edit'}</button>,
    },{
      name: '',
      button: true,
      cell: (row) => <i class="fas fa-trash" style={{display:(row.node.Status == 'Processed')?'none':'inline'}} onClick={() => deleteReport(row,row.node.FileGUID)} ></i>,
    }];



  // const { data, loading, error } = useQuery(GET_MY_REPORTS, {
  //     variables: { SupplierLogID:JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.name }
  // });

  useEffect(() => {
    if (localStorage.getItem("vendorFromDate")) {
      if (moment(localStorage.getItem("vendorFromDate"))) {
        setFromDate(moment(localStorage.getItem("vendorFromDate")));
      }
    }
    if (localStorage.getItem("vendorToDate")) {
      if (moment(localStorage.getItem("vendorToDate"))) {
        setToDate(moment(localStorage.getItem("vendorToDate")));
      }
    }

    // let showReleaseNotes_status = localStorage.getItem("showReleaseNotes");
    // if (!showReleaseNotes_status) {
    //   setShowReleaseNotes(true);
    //   localStorage.setItem("showReleaseNotes", true);
    //   fetch(changelog)
    //     .then((res) => res.text())
    //     .then((text) => {
    //       setReleaseNoteContent(text);
    //     });
    // }
    // if (JSON.parse(localStorage.getItem('searchState') && JSON.parse(localStorage.getItem('searchState')).fromDate)) {
    //   //console.log(JSON.parse(localStorage.getItem('searchState')).fromDate)
    //   setFromDate(moment(JSON.parse(localStorage.getItem('searchState')).fromDate));
    // }
    if (data) {
      if (data.VendorADAcntMap.edges.length > 0) {
        ReactGA.initialize(config[window.location.hostname].ga_tracker, {
          debug: true,
          titleCase: false,
          gaOptions: {
            userId: JSON.parse(localStorage.getItem("okta-token-storage"))
              .idToken.claims.name,
          },
        });
        ReactGA.pageview(window.location.pathname + window.location.search);
        setDisableTiles(false);
        if (localStorage.getItem("vendorChanged")) {
          if (data.VendorADAcntMap.edges.length > 1) {
            setShowVendorList(true);
          }
        } else {
          localStorage.setItem(
            "loggedInVendor",
            data.VendorADAcntMap.edges[0].node.VendorNum
          );
          localStorage.setItem(
            "loggedInVendorName",
            data.VendorADAcntMap.edges[0].node.VendorName
          );
          //console.log(data.VendorADAcntMap.edges);
          if (data.VendorADAcntMap.edges.length > 1) {
            setShowVendorList(true);
          }
        }

        setShowProcessing(true);
        getMyReports({
          variables: {
            // SupplierLogID: JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.preferred_username,
            VendorNum: localStorage.getItem("loggedInVendor"),
            Status: ["Draft", "In Progress", "Submitted"],
            FromDate: fromDate,
            ToDate: toDate,
            PartNum: "%%",
            PONum: "%%",
            MasterLot: "%%",
            SubLot: "%%",
            // SupplierLogID:JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.name
          },
        });
      } else {
        if (window.location.hostname == "localhost") {
          localStorage.setItem("loggedInVendor", "100059");
          setShowProcessing(true);
          getMyReports({
            variables: {
              // SupplierLogID: JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.preferred_username,
              VendorNum: localStorage.getItem("loggedInVendor"),
              Status: ["Draft", "In Progress", "Submitted"],
              FromDate: fromDate,
              ToDate: toDate,
              PartNum: "%%",
              PONum: "%%",
              MasterLot: "%%",
              SubLot: "%%",
              // SupplierLogID:JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.name
            },
          });
          setDisableTiles(false);
        } else {
          localStorage.removeItem("loggedInVendor");
          setShowInvalidUser(true);
        }
      }
    }
  }, [data]);
  // useEffect(() => {
  //   ResinService.getResinSettings()
  //   .then(data => {
  //     localStorage.setItem("resinSettings", JSON.stringify(data));
  //     setResinSettingsLoaded(true)
  //     const authorizedResinGroups = data["authorized_groups"]
  //     const loggedInUserGroups = JSON.parse(localStorage.getItem('quserinfo'))['groups'];
  //     const commonGroupsBetweenResinAndUserGroups = authorizedResinGroups.filter(value => loggedInUserGroups.includes(value));
  //     if (commonGroupsBetweenResinAndUserGroups.length > 0) {
  //       setShowResinTile(true)
  //     }
  //   })
  // })

  const openFileUpload = () => {
    history.push({
      pathname: 'upload_create'
    });
  }

  const openTemplateDownload = () => {
    history.push({
      pathname: 'template_download'
    });
  }

  const openNewReport = () => {
    localStorage.removeItem('selectedFile');
    history.push({
      pathname: 'newreport',
      FileGUID: 'new'
    });
  }
  // const openResinDatabase = () => {
  //   history.push({
  //     pathname: 'resin_data'
  //   });
  // }

  const deleteReport = (row,FileGUID) => {
    setSelectedRow(row);
    console.log(row);
    setShowDeletePrompt(true);
  
  }

  const DeleteReportData = (status) => {
    setShowDeletePrompt(false);
    setShowProcessing(true);
    const token = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken;
    let url = window.location.origin + '/delete_report';
    if (window.location.hostname == 'localhost') {
      url = 'http://' + window.location.hostname + ':5000/delete_report';
    }

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'responseType': 'application/octet-stream',
        'authorization': token || null,
        'reportFileGUID': selectedRow.node.FileGUID,
        'userID': JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.preferred_username,
        'authVendorID': localStorage.getItem('loggedInVendor')
      }
    }).then(res => {
      // FileSaver.saveAs(blob, 'Inspection_details' + fileGuid + '.xlsx');
      setShowProcessing(false);
      // setShowLoader(false);
         getMyReports({
          variables: {
            // SupplierLogID: JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.preferred_username,
            VendorNum: localStorage.getItem('loggedInVendor'),
            Status: (listMode != 'Processed')?["Draft", "In Progress","Submitted"]: ['Processed'],
            FromDate: fromDate, ToDate: toDate,
            PartNum:'%' + PartNumber + '%',PONum:'%' + PONumber + '%', MasterLot: '%' + masterLot + '%', SubLot: '%' + subLot + '%'
            // SupplierLogID:JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.name
          }
        });
    }).catch(err => alert('Unable to download data'));


  }


  const editReport = (row,FileGUID) => {
    setSelectedRow(row);
    console.log(row);
    if (row.node.LatestPlanID != row.node.factPlanID && row.node.factPlanID !== BLANK_PLAN_ID && row.node.Status != 'Processed') {
      setShowPlanChange(true);

    } else {
    history.push({
      pathname: 'newreport',
      FileGUID: FileGUID
    });
    localStorage.setItem('selectedFile',FileGUID);
  }
  }

  

  

  const  [debouncedCallback] =  useDebouncedCallback((value) => {        
         getMyReports({
          variables: {
            // SupplierLogID: JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.preferred_username,
            VendorNum: localStorage.getItem('loggedInVendor'),
            Status: (listMode != 'Processed')?["Draft", "In Progress","Submitted"]: ['Processed'],
            FromDate: fromDate, ToDate: toDate,
            PartNum:'%' + PartNumber + '%',PONum:'%' + PONumber + '%', MasterLot: '%' + masterLot + '%', SubLot: '%' + subLot + '%'
            // SupplierLogID:JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.name
          }
        });
    
    
  },1000);
  
  

  let now = new Date();
  let start = moment(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0,0,0,0)).tz('America/Los_Angeles');
  let end = moment(start).add(1, "days").subtract(1, "seconds").tz('America/Los_Angeles');
  let ranges = {
    "Today Only": [moment(start).tz('America/Los_Angeles'), moment(end).tz('America/Los_Angeles')],
    "Yesterday Only": [
      moment(start).subtract(1, "days").tz('America/Los_Angeles'),
      moment(end).subtract(1, "days").tz('America/Los_Angeles')
    ],
    "3 Days": [moment(start).subtract(3, "days").tz('America/Los_Angeles'), moment(end).tz('America/Los_Angeles')],
    "5 Days": [moment(start).subtract(5, "days").tz('America/Los_Angeles'), moment(end).tz('America/Los_Angeles')],
    "1 Week": [moment(start).subtract(7, "days").tz('America/Los_Angeles'), moment(end).tz('America/Los_Angeles')],
    "2 Weeks": [moment(start).subtract(14, "days").tz('America/Los_Angeles'), moment(end).tz('America/Los_Angeles')],
    "1 Month": [moment(start).subtract(1, "months").tz('America/Los_Angeles'), moment(end).tz('America/Los_Angeles')],
    "3 Months": [moment(start).subtract(3, "months").tz('America/Los_Angeles'), moment(end).tz('America/Los_Angeles')],
    "6 Months": [moment(start).subtract(6, "months").tz('America/Los_Angeles'), moment(end).tz('America/Los_Angeles')],
    "1 Year": [moment(start).subtract(1, "years").tz('America/Los_Angeles'), moment(end).tz('America/Los_Angeles')]
  };
  let local = {
      "format":"DD-MM-YYYY HH:mm",
      "sundayFirst" : false
  }
  let maxDate = moment(start).add(24, "hour").tz('America/Los_Angeles');

  const changeVendor = (el) => {
        localStorage.setItem('loggedInVendor', el.node.VendorNum);
        localStorage.setItem('loggedInVendorName', el.node.VendorName);
        localStorage.setItem("vendorChanged", true);
        window.location.reload();
  }

  const DownloadAndReset = (download) => {
    setShowPlanChange(false);
    setShowProcessing(true);

    getPlanDetailsData({
      variables: {
        PlanID: selectedRow.node.factPlanID
      }
    });
  }

  const applyCallback = (startDate, endDate) => {
    
    setFromDate(moment(startDate));
    localStorage.setItem('vendorFromDate', moment(startDate));
    localStorage.setItem('vendorToDate', moment(endDate));
    setToDate(moment(endDate));
    
    getMyReports({
      variables: {
        VendorNum: localStorage.getItem('loggedInVendor'),
        Status: (listMode != 'Processed')?["Draft", "In Progress","Submitted"]: ['Processed'],
        FromDate: startDate, ToDate: endDate,
        PartNum:'%%',PONum:'%%', MasterLot: '%%', SubLot: '%%'
      }
    });
 }

  const vendorList = (!data || !data.VendorADAcntMap) ? null : data.VendorADAcntMap.edges.map((el, i) => {
          return (
            <DropdownItem onClick={() => changeVendor(el)}>{el.node.VendorName + ' ( ' + el.node.VendorNum + ' ) ' }</DropdownItem>
          // <option value={el.node.VendorNum}>{el.node.VendorName}</option>
          )

  });

  const ShowVRNoticiations = () => {
   
    history.push({
      pathname: '/supplier/VRNotifications'
    });
 
}


const ShowFAIRNotifications = () => {
   
  history.push({
    pathname: '/supplier/FAIRNotifications'
  });

}
  const navigateHome = () => {
   
      history.push({
        pathname: '/supplier/LandingPage'
      });
   
  }



  return (
    <Fragment>
      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}
      >
        <div>
          {/* <Navbar color="light" light expand="md">
            <NavbarBrand href="/"><img src={mainLogo} />Measurement Data Analytics</NavbarBrand>
            <div className="app-header-right">
              <UserBox />
            </div>
          </Navbar> */}
          <div style={{ margin: "1%" }}>
            {data && data.VendorADAcntMap.edges.length > 0 ? (
              <>
                <div style={{ fontSize: "1.4rem" }}>
                  {" "}
                  Welcome{" "}
                  {
                    JSON.parse(localStorage.getItem("okta-token-storage"))
                      .idToken.claims.name
                  }
                  !
                </div>
              </>
            ) : null}
            {showVendorList ? (
              <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle caret>
                  {localStorage.getItem("loggedInVendorName")}
                </DropdownToggle>
                <DropdownMenu>{vendorList}</DropdownMenu>
              </Dropdown>
            ) : (
              <div style={{ fontSize: ".8rem" }}>
                {localStorage.getItem("loggedInVendorName")}
              </div>
            )}
            <Row style={{ marginTop: "5px" }}>
              <Col>
                <Row>
                  <Col md="3">
                    <div
                      style={{
                        display: diabledTiles ? "none" : "block",
                        cursor: "pointer",
                      }}
                      className="card mb-3 bg-arielle-smile widget-chart text-white card-border"
                      onClick={openNewReport}
                    >
                      <div className="icon-wrapper rounded-circle">
                        <div className="icon-wrapper-bg bg-white opacity-10" />
                        <i className="lnr-cog icon-gradient bg-arielle-smile" />
                      </div>
                      <div className="widget-heading-new">
                        Create New Inspection Report
                      </div>
                    </div>
                  </Col>
                  {/* {
                  showResinTile &&
                  <Col md="3">
                    <div
                      style={{
                        display: diabledTiles ? "none" : "block",
                        cursor: "pointer",
                      }}
                      className="card mb-3 bg-arielle-smile widget-chart text-white card-border"
                      onClick={openResinDatabase}
                    >
                      <div className="icon-wrapper rounded-circle">
                        <div className="icon-wrapper-bg bg-white opacity-10" />
                        <i className="lnr-cog icon-gradient bg-arielle-smile" />
                      </div>
                      <div className="widget-heading-new">
                        Resin Database
                      </div>
                    </div>
                  </Col>
                  } */}

                  {/* <Col md="3">
                    <div
                      style={{
                        display: diabledTiles ? "none" : "block",
                        cursor: "pointer",
                      }}
                      className="card mb-3 bg-arielle-smile widget-chart text-white card-border"
                      onClick={ShowVRNoticiations}
                    >
                      <div className="icon-wrapper rounded-circle">
                        <div className="icon-wrapper-bg bg-white opacity-10" />
                        <i className="lnr-cog icon-gradient bg-arielle-smile" />
                      </div>
                      <div className="widget-heading-new">VR Notifications</div>
                    </div>
                  </Col>

                  <Col md="3">
                    <div
                      style={{
                        display: diabledTiles ? "none" : "block",
                        cursor: "pointer",
                      }}
                      className="card mb-3 bg-arielle-smile widget-chart text-white card-border"
                      onClick={ShowFAIRNotifications}
                    >
                      <div className="icon-wrapper rounded-circle">
                        <div className="icon-wrapper-bg bg-white opacity-10" />
                        <i className="lnr-cog icon-gradient bg-arielle-smile" />
                      </div>
                      <div className="widget-heading-new">FAIR Notifications</div>
                    </div>
                  </Col> */}
                  {/* <Col md="3">
                    <div style={{ cursor: 'pointer'}} className="card mb-3 bg-arielle-smile widget-chart text-white card-border" onClick={openFileUpload}>
                      <div className="icon-wrapper rounded-circle">
                        <div className="icon-wrapper-bg bg-white opacity-10" />
                        <i className="lnr-cog icon-gradient bg-arielle-smile" />
                      </div>
                      <div className="widget-heading-new">
                        Upload Files
                                      </div>


                    </div>
                    </Col>
                    <Col md="3">
                    <div style={{ cursor: 'pointer'}} className="card mb-3 bg-arielle-smile widget-chart text-white card-border" onClick={openTemplateDownload}>
                      <div className="icon-wrapper rounded-circle">
                        <div className="icon-wrapper-bg bg-white opacity-10" />
                        <i className="lnr-cog icon-gradient bg-arielle-smile" />
                      </div>
                      <div className="widget-heading-new">
                       Download Plan Templates
                                      </div>


                    </div>
                    </Col> */}
                  {/* <Col md="3">
                    <div style={{ display: (diabledTiles ? 'none' : 'block'), cursor: 'pointer' }} className="card mb-3 bg-midnight-bloom widget-chart text-white card-border" onClick={OpenAnalytics}>
                      <div className="icon-wrapper rounded">
                        <div className="icon-wrapper-bg bg-white opacity-10" />
                        <i className="lnr-screen icon-gradient bg-warm-flame" />
                      </div>
                      <div className="widget-heading-new">
                        Analytics
                                      </div>

                    </div>
                  </Col> */}

                  <Col md="3">
                    <div
                      style={{ display: "none", cursor: "pointer" }}
                      className="card mb-3 bg-love-kiss widget-chart card-border"
                    >
                      <div className="widget-chart-content text-white">
                        <div className="icon-wrapper rounded-circle">
                          <div className="icon-wrapper-bg bg-white opacity-4" />
                          <i className="lnr-cog" />
                        </div>
                        <div className="widget-heading-new">Reports</div>
                      </div>
                      <div className="widget-chart-wrapper">
                        <ResponsiveContainer width="100%" aspect={3.0 / 1.0}>
                          <LineChart
                            margin={{ top: 0, right: 5, left: 5, bottom: 0 }}
                          >
                            <Line
                              type="monotone"
                              dataKey="pv"
                              stroke="#ffffff"
                              strokeWidth={3}
                            />
                          </LineChart>
                        </ResponsiveContainer>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row>
              <Col md="12" style={{ display: diabledTiles ? "none" : "block" }}>
                <Card className="main-card mb-3">
                  <div className="card-header">
                    <Col>Updated Between:</Col>

                    <Col sm={2}>
                      {fromDate ? (
                        <DateTimeRangeContainer
                          ranges={ranges}
                          start={fromDate}
                          end={toDate}
                          local={local}
                          maxDate={maxDate}
                          applyCallback={applyCallback}
                        >
                          <FormControl
                            id="formControlsTextB"
                            type="text"
                            label="Text"
                            placeholder="Selecte Dates"
                            value={
                              fromDate.format("MM/DD/YYYY HH:mm") +
                              " - " +
                              toDate.format("MM/DD/YYYY HH:mm")
                            }
                          />
                        </DateTimeRangeContainer>
                      ) : null}
                    </Col>
                    <Col sm={2}>
                      <Input
                        id="posearch"
                        onChange={(e) => {
                          setPONumber(e.target.value);
                          debouncedCallback(e.target.value);
                        }}
                        placeholder="PO Number"
                      />
                    </Col>
                    <Col>
                      <Input
                        id="matsearch"
                        onChange={(e) => {
                          setPartNumber(e.target.value);
                          debouncedCallback(e.target.value);
                        }}
                        placeholder="Material #"
                      />
                    </Col>
                    <Col>
                      <Input
                        id="masterlotSearch"
                        onChange={(e) => {
                          setMasterLot(e.target.value);
                          debouncedCallback(e.target.value);
                        }}
                        placeholder="Master Lot #"
                      />
                    </Col>
                    <Col>
                      <Input
                        id="sublotSearch"
                        onChange={(e) => {
                          setSubLot(e.target.value);
                          debouncedCallback(e.target.value);
                        }}
                        placeholder="Sub Lot #"
                      />
                    </Col>

                    <Col sm={4}>
                      <div>
                        <label
                          className="radio-inline"
                          style={{ margin: "5px" }}
                        >
                          <input
                            style={{ margin: "5px" }}
                            color="primary"
                            onClick={() => {
                              setShowProcessing(true);
                              setListMode("Open");
                              getMyReports({
                                variables: {
                                  VendorNum:
                                    localStorage.getItem("loggedInVendor"),
                                  Status: ["Draft", "In Progress", "Submitted"],
                                  FromDate: fromDate,
                                  ToDate: toDate,
                                  PartNum: "%" + PartNumber + "%",
                                  PONum: "%" + PONumber + "%",
                                  MasterLot: "%" + masterLot + "%",
                                  SubLot: "%" + subLot + "%",
                                },
                              });
                            }}
                            type="radio"
                            name="optradio"
                            defaultChecked={listMode == "Open" ? true : false}
                          />
                          Draft
                        </label>
                        <label
                          style={{ margin: "5px" }}
                          className="radio-inline"
                        >
                          <input
                            style={{ margin: "5px" }}
                            color="warning"
                            onClick={() => {
                              setShowProcessing(true);
                              setListMode("Processed");
                              getMyReports({
                                variables: {
                                  VendorNum:
                                    localStorage.getItem("loggedInVendor"),
                                  Status: ["Processed"],
                                  FromDate: fromDate,
                                  ToDate: toDate,
                                  PartNum: "%" + PartNumber + "%",
                                  PONum: "%" + PONumber + "%",
                                  MasterLot: "%" + masterLot + "%",
                                  SubLot: "%" + subLot + "%",
                                },
                              });
                            }}
                            type="radio"
                            name="optradio"
                            defaultChecked={
                              listMode == "Processed" ? true : false
                            }
                          />
                          Submitted
                        </label>
                        <label
                          style={{ margin: "5px" }}
                          className="radio-inline"
                        >
                          <input
                            style={{ margin: "5px" }}
                            color="warning"
                            onClick={() => {
                              setShowProcessing(true);
                              setListMode("OpenForUpload");
                              getMyReports({
                                variables: {
                                  VendorNum:
                                    localStorage.getItem("loggedInVendor"),
                                  Status: ["Processed"],
                                  FromDate: fromDate,
                                  ToDate: toDate,
                                  PartNum: "%" + PartNumber + "%",
                                  PONum: "%" + PONumber + "%",
                                  MasterLot: "%" + masterLot + "%",
                                  SubLot: "%" + subLot + "%",
                                },
                              });
                            }}
                            type="radio"
                            name="optradio"
                            defaultChecked={
                              listMode == "Processed" ? true : false
                            }
                          />
                          Open for Upload
                        </label>
                        {/* <div role="group" className="btn-group-sm btn-group">
                                           
                                                <Button color="primary" onClick={() => getMyReports({variables: { VendorNum: localStorage.getItem('loggedInVendor'),Status:["Draft","In Progress","Submitted"] }})}>Open</Button>
                                                <Button color="warning" onClick={() => getMyReports({variables: { VendorNum: localStorage.getItem('loggedInVendor') ,Status:["Processed"]}})}>Processed</Button>
                                            </div> */}
                      </div>
                    </Col>
                  </div>

                  {myReports ? (
                    <>
                      {/* <Col sm={4}>
                       <Row>
                       <Col>
                       <Label for="fromAuditDate">From:</Label>
                       <Datetime name='fromAuditDate'  value={fromDate} onChange={(e) => { changeFromDate(e) }} input={true}  defaultValue=""  /> 
                       </Col>
                       <Col>
                       <Label for="toAuditDate">To:</Label>
                       <Datetime name='toAuditDate'  value={toDate} onChange={(e) => { changeToDate(e) }} input={true}  defaultValue=""  /> 
                       </Col>
                       </Row>
       
                     </Col> */}

                      <div className="table-responsive">
                        <DataTable
                          title="Google Sheets-esqe"
                          columns={listMode == "Open" ? columns : columns1}
                          data={myReports}
                          highlightOnHover
                          pointerOnHover
                          pagination
                        />
                      </div>
                    </>
                  ) : null}
                </Card>
              </Col>
            </Row>
          </div>
        </div>

        <SweetAlert
          show={showInvalidUser}
          title="Error"
          text="Invalid User, no vendor mapping, Please contact Administrator"
          onConfirm={() => {
            setShowInvalidUser(false);
            setDisableTiles(true);
            // history.push({
            //     pathname: '/login'
            //   });
          }}
        />

        <SweetAlert
          show={showDeletePrompt}
          warning
          showCancel
          confirmBtnText="Yes, Delete Report"
          confirmBtnBsStyle="danger"
          title="Delete Report?"
          onConfirm={() => DeleteReportData(true)}
          onCancel={() => setShowDeletePrompt(false)}
          focusCancelBtn
        >
          Data will be deleted and cannot be recovered.
        </SweetAlert>

        <SweetAlert
          show={showPlanChange}
          warning
          showCancel
          confirmBtnText="Yes, Download and Reset"
          confirmBtnBsStyle="danger"
          title="Inspection Plan Changed"
          onConfirm={() => DownloadAndReset(true)}
          onCancel={() => setShowPlanChange(false)}
          focusCancelBtn
        >
          Download data and reset.
        </SweetAlert>

        <Modal scrollable isOpen={showReleaseNotes} toggle={showReleaseNotes}>
          <ModalHeader toggle={() => setShowReleaseNotes(false)}>
            VPI Supplier Portal Release Notes
          </ModalHeader>
          <ModalBody>
            <ReactMarkdown>{releaseNoteContent}</ReactMarkdown>
          </ModalBody>
          <ModalFooter>
            <Label check>
              <Input
                type="checkbox"
                onChange={(e) =>
                  {localStorage.setItem("showReleaseNotes", !e.target.checked);}
                }
              />{" "}
              Don't show this message again
            </Label>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={showProcessing}
          style={{ backgroundColor: "transparent" }}
        >
          <ModalBody>
            <div
              style={{
                width: "100%",
                textAlign: "center",
                marginTop: "20px",
                verticalAlign: "center",
              }}
            >
              <div
                style={{
                  marginLeft: "auto",
                  marginRight: "auto",
                  verticalAlign: "center",
                }}
                class="loader"
              ></div>
              Loading .....
            </div>
          </ModalBody>
        </Modal>
      </ReactCSSTransitionGroup>
    </Fragment>
  );

}

export default withAuth(withRouter(MainPage))